import { matchValues } from '@shared/core/types/common';

const expandedSectionFeel: OLO.Components.EXPANDED_SECTION_FEEL[] = ['primary', 'secondary'];

export const expandedSectionFeelType = matchValues(...expandedSectionFeel);
